import React from 'react'
import { Tabs, TabList, TabPanel, Tab } from 'react-tabs'
import { DarkBlueBadge } from '../data-card/data-card-parts'
import { Details, Row, Block } from '../details/details'

import WorkOrderCommentsContainer from '../../containers/comments/work-order-comments-container'
import WorkOrderMessagesContainer from '../../containers/messages/work-order-messages-container'
import ServicingSummaryList from '../servicings/servicing-summary-list'
import ServicingSummaryContainer from '../../containers/servicings/servicing-summary-container'
import ServiceSummariesContainer from '../../containers/service-summaries/service-summaries-container'
import TechnicianServiceSummariesContainer from '../../containers/service-summaries/technician-service-summaries-container'

// const TechnicianServiceSummariesContainer = props => <div>{props.workOrderId}</div>

export default ({
  workOrder,
  servicings,
  onTabSelect,
  selectedTab,
  hasNextPage,
  loadingServicings,
  onLoadNextPage
}) => (
  <Tabs className='tabs' onSelect={onTabSelect} selectedIndex={selectedTab}>
    <TabList>
      <Tab>Summary</Tab>
      <Tab>Work Details</Tab>
      <Tab>Comments <DarkBlueBadge text={workOrder.commentsCount} /></Tab>
      <Tab>Messages</Tab>
    </TabList>

    <TabPanel>
      <Details>
        <Row>
          <Block title="Completed Services">
            <ServiceSummariesContainer workOrderId={workOrder.id} />
          </Block>
          <Block title="Assigned Technicians">
            <TechnicianServiceSummariesContainer workOrderId={workOrder.id} />
          </Block>
        </Row>
      </Details>
    </TabPanel>

    <TabPanel>
      {listServicings(servicings, workOrder, hasNextPage, onLoadNextPage, loadingServicings)}
    </TabPanel>

    <TabPanel>
      <WorkOrderCommentsContainer workOrderId={workOrder.id} />
    </TabPanel>

    <TabPanel>
      <WorkOrderMessagesContainer workOrderId={workOrder.id} />
    </TabPanel>
  </Tabs>
)

function listServicings (servicings, workOrder, hasNextPage, onLoadNextPage, loading) {
  if ((servicings || []).length) {
    return (
      <ServicingSummaryList>
        {servicings.map(servicing => mapper(servicing, workOrder.id))}

        {hasNextPage &&
          <div className='card load-more' onClick={onLoadNextPage}>
            Load more...
          </div>}
      </ServicingSummaryList>
    )
  } else {
    return <p className='no-content'>{loading ? 'Loading...' : 'No areas found.'}</p>
  }
}

function mapper (servicing, workOrderId) {
  return <ServicingSummaryContainer workOrderId={workOrderId} readonly key={servicing.id} servicingId={servicing.id} />
}



// WEBPACK FOOTER //
// ./src/components/work-summaries/work-summary-work-order-tabs-signed-off.js